var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('notification-detail-table',{attrs:{"title":"Офферы","items":_vm.notification.offers,"filters":_vm.filters,"headers":_vm.headers,"statuses":_vm.statuses,"actions":_vm.actions,"routes":_vm.routes,"icon":_vm.SvgOffers}})
}
var staticRenderFns = []

export { render, staticRenderFns }